import * as React from 'react';
import { Kvika } from '@kvika/logos';
import { StyledChildrenContainer, StyledHeader, StyledLogo } from './styles/HeaderStyles';
var Header = function (_a) {
    var testId = _a.testId, children = _a.children, logo = _a.logo, _b = _a.height, height = _b === void 0 ? '112px' : _b, _c = _a.width, width = _c === void 0 ? '100%' : _c, className = _a.className;
    return (React.createElement(StyledHeader, { className: className, "data-testid": testId, height: height, width: width, role: "heading" },
        React.createElement(StyledLogo, null, logo || React.createElement(Kvika, { width: 133, "data-testid": "".concat(testId, "-logo") })),
        React.createElement(StyledChildrenContainer, null, children)));
};
export default Header;
//# sourceMappingURL=Header.js.map